import { BaseApplicationError } from '@swoft/core';

/**
 * GTD Feature Application Errors
 * 
 * Provides structured error handling for GTD feature operations
 * with user and developer suggestions.
 */
export class GTDFeatureError extends BaseApplicationError {
  readonly code = 'GTD_FEATURE_ERROR';

  constructor(message: string, cause?: unknown) {
    super(
      message,
      {
        ux: ['Please try again', 'Contact support if the problem persists'],
        dx: ['Check GTD domain integration', 'Verify @swoft/gtd-domain package']
      },
      cause
    );
  }
}

export class GTDValidationError extends BaseApplicationError {
  readonly code = 'GTD_VALIDATION_ERROR';

  constructor(message: string, cause?: unknown) {
    super(
      message,
      {
        ux: ['Please check your input and try again'],
        dx: ['Check Zodios validation schema', 'Verify request format']
      },
      cause
    );
  }
}

export class GTDDomainIntegrationError extends BaseApplicationError {
  readonly code = 'GTD_DOMAIN_INTEGRATION_ERROR';

  constructor(message: string, cause?: unknown) {
    super(
      message,
      {
        ux: ['Something went wrong processing your request'],
        dx: ['Check @swoft/gtd-domain domain integration', 'Verify domain aggregate calls']
      },
      cause
    );
  }
}
